import {gql} from "@apollo/client"

export const GET_TAXONOMY_TREE = gql`
    query get_taxonomy_tree {
        taxonomyTree {
            name
            children {
                name
                id
                machineName
            }
        }
    }
`

export const GET_INSTRUCTORS = gql`
    query get_instructors($cid: String, $tid: String) {
        instructors(cid: $cid, tid: $tid) {
            page
            pages
            objects {
                name
                id
            }
        } 
    }
`

export const GET_TECHNIQUES = gql`
    query get_techniques($cid: String!) {
        techniques(cid: $cid) {
            name
            id
            machineName
        }
    }
`

export const GET_TECHNIQUES_TREE = gql`
    query get_techniques_tree($parent: String) {
        taxonomyChildren(parent: $parent) {
            id
            name
            children {
                id
                name
            }
        }
    }
`

export const TAXONOMY_TREE = gql`
    query taxonomy_tree($depth: Int) {
        taxonomyTree (depth: $depth) {
            name
            id
            children {
                name
                id
                machineName
            }
        }
    }
`